import BaseApiService from "@/api/BaseApiService"
import proxy from "@/api/proxy"

const ValidationService = {
  ValidatePhoneNumber(phoneNumber: string) {
    return BaseApiService.getAsync(proxy.SecurityV2, `Validate?phoneNumber=${encodeURIComponent(phoneNumber)}`)
  },
}
export default ValidationService
